export default "__VITE_ASSET__a175fc7c__"